import { OrderType, useGetMyNotificationsQuery } from '@exam-center/graphql';
import { NetworkStatus } from '@shared/apollo';
import { useState } from 'react';

const PAGE_SIZE = 10;

export function useGetMyNotifications() {
  const [currentPage, setCurrentPage] = useState(0);

  const { data, fetchMore, networkStatus } = useGetMyNotificationsQuery({
    variables: {
      getMyNotificationsInput: {
        order: {
          field: 'createdAt',
          type: OrderType.Desc,
        },
        paging: {
          currentPage: 0,
          pageSize: PAGE_SIZE,
        },
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  const notificationsData = data?.ecGetMyNotifications.notificationRecipients ?? [];
  const total = data?.ecGetMyNotifications.total ?? 0;
  const hasMore = notificationsData.length < total;
  const isInitialLoading = networkStatus === NetworkStatus.loading;
  const isFetchingMore = networkStatus === NetworkStatus.fetchMore;

  const handleFetchMore = async () => {
    const nextPage = currentPage + 1;
    await fetchMore({
      variables: {
        getMyNotificationsInput: {
          order: {
            field: 'createdAt',
            type: OrderType.Desc,
          },
          paging: {
            currentPage: nextPage,
            pageSize: PAGE_SIZE,
          },
        },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) return previousResult;

        return {
          ecGetMyNotifications: {
            ...fetchMoreResult.ecGetMyNotifications,
            notificationRecipients: [
              ...previousResult.ecGetMyNotifications.notificationRecipients,
              ...fetchMoreResult.ecGetMyNotifications.notificationRecipients,
            ],
          },
        };
      },
    });
    setCurrentPage(nextPage);
  };

  return {
    notificationsData,
    isInitialLoading,
    isFetchingMore,
    hasMore,
    handleFetchMore,
  };
}
